const scaleCorrectors = {};
function addScaleCorrector(correctors) {
  Object.assign(scaleCorrectors, correctors);
}
export {
  addScaleCorrector,
  scaleCorrectors
};
//# sourceMappingURL=scale-correction.js.map
